"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Category = exports.Subtype = exports.Type = void 0;
var Type;
(function (Type) {
    Type["Book"] = "book";
    Type["App"] = "app";
    Type["Course"] = "course";
    Type["Other"] = "other";
})(Type || (exports.Type = Type = {}));
var Subtype;
(function (Subtype) {
    Subtype["Online"] = "online";
    Subtype["Classroom"] = "classroom";
})(Subtype || (exports.Subtype = Subtype = {}));
var Category;
(function (Category) {
    Category["Sports"] = "sports";
    Category["Interviews"] = "interviews";
    Category["Certificates"] = "certificates";
    Category["ISPC"] = "ispc";
    Category["FaceToFace"] = "face-to-face";
    Category["Online"] = "online";
    Category["PL"] = "pl";
    Category["Books"] = "books";
    Category["Audios"] = "audios";
    Category["Psicos"] = "psicos";
    Category["Mossos"] = "mossos";
    Category["GUB"] = "gub";
    Category["Others"] = "others";
    Category["Packs"] = "packs";
    Category["Atlantic"] = "atlantic";
    Category["CP"] = "cp";
    Category["Bulevard"] = "bulevard";
    Category["PMM"] = "pmm";
    Category["PLANES"] = "planes";
    Category["FASE1"] = "fase1";
    Category["FASE2"] = "fase2";
    Category["FASE3"] = "fase3";
    Category["FASE4"] = "fase4";
    Category["CURSOS_POLICIALES"] = "cursos-policiales";
    Category["DERECHO_PENAL_Y_PROCESAL"] = "derecho-penal-y-procesal";
    Category["DERECHO_ADMINISTRATIVO_Y_REGIMEN_SANCIONADOR"] = "derecho-administrativo-y-regimen-sancionador";
    Category["TRAFICO_Y_SEGURIDAD_VIAL"] = "trafico-y-seguridad-vial";
    Category["MEDICINA_LEGAL_Y_ASISTENCIA_SANITARIA"] = "medicina-legal-y-asistencia-sanitaria";
    Category["INTERVENCION_POLICIAL_Y_USO_DE_LA_FUERZA"] = "intervencion-policial-y-uso-de-la-fuerza";
    Category["TECNOLOGIAS_Y_CIBERSEGURIDAD"] = "tecnologias-y-ciberseguridad";
    Category["POLICIA_JUDICIAL_E_INVESTIGACION"] = "policia-judicial-e-investigacion";
    Category["PROTECCION_Y_ATENCION_A_LA_CIUDADANIA"] = "proteccion-y-atencion-a-la-ciudadania";
    Category["FORMACION_ESPECIFICA_PARA_UNIDADES"] = "formacion-especifica-para-unidades";
    Category["FORMACION_GENERAL_Y_ETICA_PROFESIONAL"] = "formacion-general-y-etica-profesional";
    Category["PROTECCION_CIVIL_Y_EMERGENCIAS"] = "proteccion-civil-y-emergencias";
    Category["CURSOS_POLICIALES_TOP"] = "cursos-policiales-top";
    Category["BOMBEROS"] = "bomberos";
    Category["APP"] = "app";
    Category["OFERTA"] = "oferta";
    Category["ARRO"] = "arro";
    Category["HOMOLOGADOS"] = "homologados";
})(Category || (exports.Category = Category = {}));
